import React, { useState } from 'react';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import moment from 'moment';
import CSSZSickLeaveCertificateRequestForChooseOutingsTimeForm, {
	CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues,
} from './CSSZSickLeaveCertificateRequestForChooseOutingsTimeForm';
import useCSSZSickLeaveForm from '../Hooks/useCSSZSickLeaveForm';
import Loading from '../../../../Components/Loading';
import JobWaiting from '../../../Base/Components/Job/JobWaiting';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	item: CSSZSickLeaveCertificate;
	patientId: string;
	onCreate: (jobId?: string) => void;
}

const CSSZSickLeaveCertificateRequestForChooseOutingsTime: React.FC<Props> = ({
	item,
	patientId,
	onCreate,
}) => {
	const [waitingJobId, setWaitingJobId] = useState<string | null>(null);
	const { showNotificationAlert, showNotificationSuccess } = useNotification();
	const { post, isLoading } = useCSSZSickLeaveForm({
		patientId,
		sickLeaveCertificate: item,
		endpoint: 'zadost-o-povoleni-moznosti-volit-dobu-vychazek',
	});

	const handleSubmit = async (
		values: CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues,
	) => {
		await post(values, (jobId?: string) => {
			if (jobId) {
				setWaitingJobId(jobId);
			} else {
				onCreate();
			}
		});
	};

	if (waitingJobId) {
		return (
			<JobWaiting
				jobId={waitingJobId}
				onJobSuccess={() => {
					setWaitingJobId(null);
					showNotificationSuccess({
						content:
							'component.CSSZSickLeaveCertificateDetailControls.requestForChooseOutingsTimeSuccess',
					});
					onCreate();
				}}
				onJobFailed={() => {
					setWaitingJobId(null);
					showNotificationAlert({
						content: 'component.jobWaiting.jobFailed',
					});
				}}
				timeout={15000}
				waitingMessage='component.jobWaiting.waitingTitle'
			/>
		);
	}

	if (isLoading) {
		return <Loading />;
	}

	return (
		<CSSZSickLeaveCertificateRequestForChooseOutingsTimeForm
			onSubmit={handleSubmit}
			defaultValues={{
				dateFrom: moment().format(),
			}}
		/>
	);
};

export default CSSZSickLeaveCertificateRequestForChooseOutingsTime;
